import './post_type_filter_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.PostFacebookTypeFilterView extends Monitoring.Views.SocialContents.Filters.PostTypeFilterView
  template: JST["backbone/templates/monitoring/filters/post_type/post_facebook_type_filter"]
  
  addFilter: (value) ->
    @searchQuery.addPostFacebookType(value)
